import { Controller } from "@hotwired/stimulus"

// Makes the admin files section a drag-and-drop target: dropped files are
// handed to the existing direct upload file input, so the evaporate flow
// stays unchanged.
export default class extends Controller {
  static targets = ["input", "zone"]

  disconnect() {
    this.deactivate()
  }

  dragOver(event) {
    event.preventDefault()
    this.activate()
  }

  dragLeave(event) {
    event.preventDefault()
    this.deactivate()
  }

  drop(event) {
    event.preventDefault()
    this.deactivate()

    if (!this.hasInputTarget) return
    if (event.dataTransfer.files.length === 0) return

    this.inputTarget.files = event.dataTransfer.files
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  activate() {
    if (this.hasZoneTarget) this.zoneTarget.classList.add("border-primary")
  }

  deactivate() {
    if (this.hasZoneTarget) this.zoneTarget.classList.remove("border-primary")
  }
}
